module.exports = __webpack_public_path__ + "img/blitz_right.1c244618.jpg";